import React, { useState } from "react";
import { LTabStrip } from "@loffa/gpp-modules";
import { AutoImportConnections } from "./AutoImportConnections/AutoImportConnections";
import { AutoimportLogs } from "./AutoimportLogs/AutoimportLogs";
import { AutoImportConfigurations } from "./AutoImportConfigurations/AutoImportConfigurations";
function Automation() {
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <div>
      <LTabStrip
        selected={selectedTab}
        onSelect={(e) => setSelectedTab(e.selected)}
        orientation="vertical"
        tabs={[
          {
            title: "Auto Import Connections",
            body: <AutoImportConnections />,
          },
          {
            title: "Auto Import Configurations",
            body: <AutoImportConfigurations />,
          },
          {
            title: "Auto Import Logs",
            body: <AutoimportLogs />,
          }
        ]}
        tabPosition="left"
      />
    </div>
  );
}

export { Automation };
